import React from "react";
import { Tabs } from "antd";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { ReactComponent as BackIcon } from "assets/img/leftArrow.svg";

import "./style.css";
import "components/Layout/style.css";
import DatePickerYear from "pages/Shared/CustomMonthYear";
import { useLocation, useNavigate } from "react-router-dom";
import AppBar from "components/Layout/AppBar";
import { crops, getTotalCahierCounts } from "./StockCahierHelper";

const ReportDetails = ({ backUrl, title, reportData, reportTabContent }) => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const Tab = ({ item }) => {
    return (
      <div>
        <h1>{item?.label}</h1>
        {item?.imgSrc}
      </div>
    );
  };

  const TabContent = ({ item }) => {
    return reportTabContent(item);
  };

  return (
    <>
      <div className="pt-4">
        <AppBar />
      </div>
      <div className="stockReportSection">
        <Grid container sx={{ padding: "25px 0px" }}>
          <Grid item xs={9}>
            <Box display={"flex"}>
              <BackIcon onClick={() => navigate(backUrl)} cursor={"pointer"} />
              <h3 className={"heading"}>{title}</h3>
            </Box>
          </Grid>
          <Grid item xs={3} sx={{ textAlign: "right" }}>
            <Box class="datepicbyyear">
              <DatePickerYear />
            </Box>
          </Grid>
        </Grid>
        <Tabs
          defaultActiveKey={state ? state?.reportData?.key : "Maïs"}
          tabPosition={"left"}
          items={crops?.map((item, i) => {
            const id = String(i + 1);
            return {
              label: <Tab item={item} />,
              key: item.label,
              children: <TabContent item={item} />,
            };
          })}
        />
      </div>
    </>
  );
};

export default ReportDetails;
